module.exports = {
	"flux": "https://facebook.github.com/flux",
	"react": "http://facebook.github.io/react",
	"source": "https://github.com/thundercatsjs/thundercats",
	"reflux": "https://github.com/spoike/refluxjs",
	"reactiveX": "http://reactivex.io/",
	"observable": "https://github.com/Reactive-Extensions/RxJS/blob/master/doc/api/core/observable.md",
	"rxjs": "https://github.com/Reactive-Extensions/RxJS",
	"logo": "http://www.lenoremessler.com/"
}


/*****************
 ** WEBPACK FOOTER
 ** ./docs/constants/urls.json
 ** module id = 221
 ** module chunks = 0
 **/